module.exports = {
	newDomainRegex: /^[a-z0-9-]+\.[a-z]+$/,
};
